import styled from "styled-components";
import COLORS from "../../constants/colors";
import FONTS from "../../constants/fonts";

export const WholeWrapper = styled.div`
  min-width: ${({small})=>small ? "22.4rem" : "30rem"};
  width: ${({small})=>small ? "22.4rem" : "30rem"};
  height: ${({small})=>small ? "21.8rem" : "35rem"};
  position: relative;
  margin-right:${({small})=>small ? "2.4rem" : "3rem"};
`;

export const CardCover = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${({ img }) => img});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 2rem;
`;

export const CardInfo = styled.div`
  width: 100%;
  height: ${({ small }) => (small ? "8.4rem" : "16rem")};
  background: white;
  border-radius: 2rem;
  position: absolute;
  bottom: 0;
  padding: ${({ small }) => (small ? "1.8rem 1.8rem 0" : "2.6rem")};
`;

export const CardInfoMain = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const CardInfoTitle = styled.div`
  font-family: ${FONTS.UbuntuMedium};
  font-size: 2.2rem;
  line-height: 2.6rem;
  margin-bottom: 1.6rem;
`;

export const CardInfoDesc = styled.div`
  font-family: ${FONTS.UbuntuLight};
  font-size: 1.6rem;
  line-height: 2.4rem;
`;

export const CardInfoFooter = styled.div`
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding-bottom: 0.8rem;
`;

export const CardInfoDownloads = styled.div`
  font-family: ${FONTS.UbuntuMedium};
  font-size: 1.3rem;
  line-height: 1.6rem;
  color: ${COLORS.secondary.morning};
  display: flex;
  align-items: center;
`;

export const CardCategory = styled.div`
  width: 4.8rem;
  height: 4.8rem;
  position: absolute;
  top: 2.4rem;
  left: 2.4rem;
  background: linear-gradient(121.45deg, #030a1b -41.87%, #026c8e 141.08%);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
